export function resolveTransactionId({ row, transactionId } = {}) {
  if (transactionId != null && String(transactionId).trim()) {
    return String(transactionId).trim();
  }
  if (!row) return "";
  return String(row?.walletTransactionId || row?.transactionId || row?._id || "").trim();
}

export async function copyTextToClipboard(text) {
  const value = String(text ?? "").trim();
  if (!value) return false;

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return true;
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  if (!copied) throw new Error("Copy failed");
  return true;
}

export async function copyTransactionIdToClipboard({
  row,
  transactionId,
  enqueueSnackbar,
  successMessage = "Transaction ID copied",
  errorMessage = "Failed to copy Transaction ID",
} = {}) {
  const txId = resolveTransactionId({ row, transactionId });
  if (!txId) return false;

  try {
    await copyTextToClipboard(txId);
    enqueueSnackbar?.(successMessage, { variant: "success" });
    return true;
  } catch {
    enqueueSnackbar?.(errorMessage, { variant: "error" });
    return false;
  }
}
